/// <reference types="@angular/localize" />
import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import 'zone.js';
import "zone.js/plugins/task-tracking"
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';


if (environment.production) {
    enableProdMode();
}

function bootstrap() {
    bootstrapApplication(AppComponent, appConfig)
        /* eslint-disable-next-line no-console
    --
    It's just an example application file. This message is not crucial
    to be logged using any special logger. Moreover, we don't have
    any special logger available in this context. */
        .catch((err) => console.error(err));
}

if (document.readyState === 'complete') {
    bootstrap();
} else {
    document.addEventListener('DOMContentLoaded', bootstrap);
}
